<template>
    <router-view></router-view>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        name: 'app',
        methods: {
            ...mapActions('school', {
                getSchoolInfo: 'getSchoolInfoAction'
            })
        },
        async created() {
            await this.getSchoolInfo();
        }
    }
</script>